import { useMutation } from "@tanstack/react-query";
import { useCallback, useMemo, useState } from "react";
import { Button, Dropdown } from "semantic-ui-react";
import { updatePromotion } from "../../../../services/PromotionCampaign/PromotionCampaign.service";
import { notify } from "react-notify-toast";
import { UltyDropdown } from "@ulty/ulty-ui";

export const EditableBarcodes = ({ readonly,promotion,currentSearch, onEdit }) => {
  const [isHovered, setIsHovered] = useState(false);

  const [showDropdown, setShowDropdown] = useState(false);
  const [barcodes, setBarcodes] = useState(promotion.barcodes || []);

  // Prepare dropdown options
  const options = useMemo(() => (barcodes || []).map(b => ({
    key: b,
    text: b,
    value: b
  })), [barcodes]);

  const handleChange = (value) => {
    setBarcodes(value);
  };

  const updatePromotionsMutation = useMutation({
    mutationFn: async (data) => {
      const result = await updatePromotion(promotion.promotionCampaignId,promotion.id, {
        barcodes: data
      })
      onEdit?.();
      return result;
    },
    onSuccess: () => {
      notify.show('Barcodes updated successfully', 'success');
    }
  });

  const handleCancel = () => {
    setShowDropdown(false);
    setBarcodes(promotion.barcodes || []);
  }

  const handleSave = useCallback(async() => {
    await updatePromotionsMutation.mutateAsync(barcodes);
    setShowDropdown(false);
  }, [barcodes, updatePromotionsMutation]);

  if(readonly || !showDropdown) {
    return (
      <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}
      {...(!readonly  && { 
          onMouseOver:() => setIsHovered(true),
          onMouseOut:() => setIsHovered(false)
      })}
      >
        {barcodes.map((barcode, index) => (
          <li
            key={index}
             {...(!readonly  && { 
                style:{
                    marginRight: '8px',
                    cursor: 'pointer'
                },
                onClick:() => setShowDropdown(true)
        })}
          >
            <span
              style={{
                color: currentSearch && currentSearch === barcode ? 'blue' : 'black',
                borderBottom: isHovered ? '1px dotted  #888' : '1px dotted transparent'
              }}
            >
              {barcode}
            </span>
          </li>
        ))}
      </ul>
    );
  }

  return (
    <div>
     <Button
              icon="save"
              color="teal"
              size="mini"
              loading={updatePromotionsMutation.isPending}
              onClick={handleSave}
              style={{ marginBottom: '8px' }}>
                Save
            </Button>
            <Button
              icon="save"
              basic
              size="mini"
              loading={updatePromotionsMutation.isPending}
              onClick={handleCancel}
              style={{ marginBottom: '8px' }}>
                Annuler
            </Button>
          <Dropdown
            selection
            multiple
            search
            options={options}
            value={barcodes}
            allowAdditions
            closeOnBlur
            onChange={(e, { value }) => handleChange(value) }
            placeholder="Barcodes"
            style={{ minWidth: 250 }}
          />
    </div>
  );
}